import { coreService } from "../../services/coreService";
import { buildQuery } from "../../lib/network";

export type CrmCustomListView = Awaited<ReturnType<typeof coreService.crmSearchDemoViewsList>>["data"][number];
export type ListViewSortField = Exclude<CrmCustomListView["sortFields"], undefined>[number];
export type ListViewColumn = Exclude<CrmCustomListView["columns"], undefined>[number];

export const getCrmCustomListViews = (headers: any) => () => {
  return buildQuery(coreService.crmSearchDemoViewsList({ headers }), (response) => {
    return response.data;
  });
};
